/** Skeleton loaders — shimmering placeholders while data loads. */
import { cn } from '../utils.js';

export function Skeleton({ className }: { className?: string }) {
  return <div className={cn('animate-pulse rounded-md bg-muted', className)} />;
}

/** A KPI-cards row placeholder. */
export function SkeletonKpis() {
  return (
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
      {[0, 1, 2, 3].map((i) => (
        <div key={i} className="rounded-xl border border-border bg-card p-5">
          <Skeleton className="h-3 w-20" />
          <Skeleton className="mt-3 h-7 w-32" />
        </div>
      ))}
    </div>
  );
}

/** A chart card placeholder — staggered bars, deterministic heights. */
export function SkeletonChart({ height = 280 }: { height?: number }) {
  return (
    <div className="rounded-xl border border-border bg-card p-6">
      <Skeleton className="mb-4 h-5 w-56" />
      <div className="flex items-end gap-2" style={{ height }}>
        {Array.from({ length: 24 }, (_, i) => (
          <div
            key={i}
            className="flex-1 animate-pulse rounded-t bg-muted"
            style={{ height: 40 + ((i * 53) % (height - 80)) }}
          />
        ))}
      </div>
    </div>
  );
}

/** A table card placeholder. */
export function SkeletonTable({ rows = 6 }: { rows?: number }) {
  return (
    <div className="rounded-xl border border-border bg-card p-6">
      <Skeleton className="mb-4 h-5 w-40" />
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="flex gap-4 border-b border-border/40 py-3">
          <Skeleton className="h-4 w-1/3" />
          <Skeleton className="h-4 w-1/4" />
          <Skeleton className="ms-auto h-4 w-16" />
        </div>
      ))}
    </div>
  );
}
